/**
 * Saga for the Lesson Planner admin slice. Mirrors preschoolEntity — the
 * mapping table dispatches to the right API call by entity name.
 */
import { takeEvery, takeLatest } from 'redux-saga/effects'

import {
  fetchPlannerGradeGroup,
  createPlannerGradeGroup,
  updatePlannerGradeGroup,
  deletePlannerGradeGroup,
  fetchPlannerSubject,
  createPlannerSubject,
  updatePlannerSubject,
  deletePlannerSubject,
  fetchPlannerLayout,
  createPlannerLayout,
  updatePlannerLayout,
  deletePlannerLayout
} from 'api'
import constants from 'app/constants'
import {
  fetchPlannerGradeGroupData,
  fetchPlannerGradeGroupDataSuccess,
  fetchPlannerSubjectData,
  fetchPlannerSubjectDataSuccess,
  fetchPlannerLayoutData,
  fetchPlannerLayoutDataSuccess,
  updatePlannerDataSuccess
} from 'app/store/actions/lessonPlannerEntity'
import * as types from 'app/store/types/lessonPlannerEntity'

import { handleFetch, handleUpdate } from './saga.helper'

const mapping = {
  [constants.PLANNER_GRADE_GROUP]: {
    api: {
      fetch: fetchPlannerGradeGroup,
      create: createPlannerGradeGroup,
      update: updatePlannerGradeGroup,
      delete: deletePlannerGradeGroup
    },
    action: {
      fetch: fetchPlannerGradeGroupData,
      fetchSuccess: fetchPlannerGradeGroupDataSuccess
    }
  },
  [constants.PLANNER_SUBJECT]: {
    api: {
      fetch: fetchPlannerSubject,
      create: createPlannerSubject,
      update: updatePlannerSubject,
      delete: deletePlannerSubject
    },
    action: {
      fetch: fetchPlannerSubjectData,
      fetchSuccess: fetchPlannerSubjectDataSuccess
    }
  },
  [constants.PLANNER_LAYOUT]: {
    api: {
      fetch: fetchPlannerLayout,
      create: createPlannerLayout,
      update: updatePlannerLayout,
      delete: deletePlannerLayout
    },
    action: {
      fetch: fetchPlannerLayoutData,
      fetchSuccess: fetchPlannerLayoutDataSuccess
    }
  }
}

export function* _fetchLessonPlannerEntity({ queries, entity } = {}) {
  const mappingData = mapping[entity]
  yield handleFetch(mappingData, queries, entity)
}

export function* _updateLessonPlannerEntity({ entity, event, value } = {}) {
  const mappingData = mapping[entity]
  yield handleUpdate(mappingData, entity, event, value, updatePlannerDataSuccess)
}

export function* watchFetchLessonPlannerEntity() {
  yield takeLatest(
    [
      types.FETCH_PLANNER_GRADE_GROUP_DATA,
      types.FETCH_PLANNER_SUBJECT_DATA,
      types.FETCH_PLANNER_LAYOUT_DATA
    ],
    _fetchLessonPlannerEntity
  )
}

export function* watchUpdateLessonPlannerEntity() {
  yield takeEvery(types.UPDATE_PLANNER_DATA, _updateLessonPlannerEntity)
}
